"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsDialog = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constants = require("../../constants");
var _useCreateCustomerAcceptedTerm = require("../../hooks/useCreateCustomerAcceptedTerm");
var _useDevice = require("../../hooks/useDevice");
var _setTermsAndConditionsCookie = require("../../utils/setTermsAndConditionsCookie");
var _AcceptCta = require("./AcceptCta");
var _DialogPage = require("./DialogPage");
var _DialogTitle = require("./DialogTitle");
var _NextCta = require("./NextCta");
var _PreviousCta = require("./PreviousCta");
var _PrintCta = require("./PrintCta");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TermsAndConditionsDialog = ({
  termId
}) => {
  const localLogger = (0, _logger.useLogger)('TermsAndConditionsDialog');
  const {
    isMobile
  } = (0, _useDevice.useDevice)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    acceptTerm
  } = (0, _useCreateCustomerAcceptedTerm.useCreateCustomerAcceptedTerm)();
  const [isDialogOpen, setIsDialogOpen] = (0, _react.useState)(true);
  const [page, setPage] = (0, _react.useState)(0);
  const [isAcceptingTermsAndConditions, setIsAcceptingTermsAndConditions] = (0, _react.useState)(false);
  const {
    data: termHtml,
    error: termHtmlFetchingError
  } = (0, _staticApiClientReact.useGetTenantTermHtml)(tenant, termId, {
    lang: language
  });
  const {
    data: autoshipLegalArticles,
    error: autoshipLegalArticlesFetchingError
  } = (0, _globalApiClientReact.useGetCustomerAutoshipLegalArticles)(customerId);
  const handleAcceptTermsAndConditions = (0, _react.useCallback)(() => {
    setIsAcceptingTermsAndConditions(true);
    acceptTerm(customerId, termId).then(() => {
      (0, _setTermsAndConditionsCookie.setTermsAndConditionsCookie)(customerId);
    }).catch(error => {
      localLogger.error(new Error(`Failed to accepting Terms and Conditions for customerId: '${customerId}' and termId: '${termId}'`, {
        cause: error
      }));
      // Suppress any error during the API call, close the dialog,
      // and display it again the next time the page is loaded.
    }).finally(() => {
      setIsAcceptingTermsAndConditions(false);
      setIsDialogOpen(false);
    });
  }, [acceptTerm, customerId, termId, localLogger]);
  const handlePage = (0, _react.useCallback)((goPage, marginIndex) => () => {
    if (page === marginIndex || goPage < -1 || goPage > 1) {
      return;
    }
    setPage(page + goPage);
  }, [page]);
  if (termHtmlFetchingError) {
    localLogger.error(new Error(`Failed to fetching TermsAndConditions for termId: '${termId}'`, {
      cause: termHtmlFetchingError
    }));
    return null;
  }
  if (autoshipLegalArticlesFetchingError) {
    localLogger.error(new Error(`Failed to fetching AutoshipLegalArticles for customerId: '${customerId}'`, {
      cause: autoshipLegalArticlesFetchingError
    }));
  }
  if (!termHtml) {
    return null;
  }
  const {
    body,
    footer,
    header,
    title
  } = termHtml;
  const pages = [header, body, footer].filter(Boolean);
  const pagesLength = pages.length;
  if (pagesLength === 0) {
    return null;
  }
  const firstPageIndex = 0;
  const lastPageIndex = pagesLength - 1;
  const isFirstPage = page === firstPageIndex;
  const isLastPage = page === lastPageIndex;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DialogStyled, {
    disableScrollLock: true,
    hideCloseButton: true,
    fullWidth: true,
    open: isDialogOpen,
    header: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle.DialogTitle, {
      content: title
    }),
    ariaLabelledby: _constants.ariaLabelledby,
    ariaDescribedby: _constants.ariaDescribedby,
    maxWidth: _constants.DIALOG_MAX_WIDTH,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogPage.DialogPage, {
        html: pages[page]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DialogActionsStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DialogPageActions, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PreviousCta.PreviousCta, {
            hidden: isFirstPage,
            fullWidth: isMobile,
            onClick: handlePage(-1, firstPageIndex)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_NextCta.NextCta, {
            hidden: isLastPage,
            fullWidth: isMobile,
            onClick: handlePage(1, lastPageIndex)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AcceptCta.AcceptCta, {
            hidden: !isLastPage,
            fullWidth: isMobile,
            disabled: isAcceptingTermsAndConditions,
            onClick: handleAcceptTermsAndConditions
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrintCta.PrintCta, {
          href: autoshipLegalArticles?.termsAndConditions?.url,
          target: "_blank"
        })]
      })]
    })
  });
};
exports.TermsAndConditionsDialog = TermsAndConditionsDialog;
